<template>
  <div class="pVodWrap vod" ref="playerBox">
    <div class="pVodInner" style="position: relative">
      <button class="pipClose" @click="vodClosed">
        {{ this.$t('broadcast.closePip') }}
      </button>
      <div class="topDiv"></div>
      <div class="pVodTop" :class="{ hide: !showHideFlag }">
        <img
          class="logo"
          src="../../assets/img/ico/logo_color.png"
        />
        <img class="live" src="../../assets/img/ico/live_ci.png" />
      </div>
      <div class="brandImg" :class="{ hide: !showHideFlag }">
        <router-link :to="brandRounting" @click.native="clickFlag">
          <div
            class="brdImgDiv"
            :style="{
              'background-image': 'url(' + vodInfo.brandImageUrl + ')',
              backgroundSize: 'contain'
            }"
          >
            <!-- <img class="brdImg" :src="urlChk(vodInfo.brandImageUrl)"> -->
          </div>
          <div class="rerDiv">
            <img
              class="rerun"
              src="../../assets/img/ico/profile_label_vod.png"
              v-if="vodInfo.broadcastType === 1"
            />
            <img
              class="rerun"
              src="../../assets/img/ico/profile_label_live.png"
              v-if="vodInfo.broadcastType === 0"
            />
          </div>
        </router-link>
        <div class="brandTxt">
          <p class="title">{{ vodInfo.title }}</p>
          <span>{{ vodInfo.brandName }}</span>
          <div class="watchCnt">
            <img src="../../assets/img/ico/icon_play_wh_sm.png" />
            <span>{{ viewCnt | makeComma }}</span>
          </div>
          <div class="likeCnt">
            <img src="../../assets/img/ico/icon_like_wh.png" />
            <span>{{ likeCnt | makeComma }}</span>
          </div>
        </div>
      </div>
      <div
        class="pVodSoundDiv"
        v-if="clickSoundBtn"
        @click="soundBtn"
        :class="{ hide: !showHideFlag }"
      >
        <button class="pVodSound" v-if="vodSound"></button>
        <button class="pVodSound off" v-if="!vodSound"></button>
      </div>
      <button class="pVodSizingBtn" @click="vodToggleSize"></button>
      <!-- <button class="pVodIconShow" :class="{'show' : showHideFlag, 'hide' : !showHideFlag}" @click="iconShowHide"></button> -->
      <!-- <div class="pVodClose">
        <button class="closeX" @click="vodClosed"></button>
      </div> -->
      <div class="bottomDiv"></div>

      <!-- 구매여기 -->
      <div class="buyHere" ref="buyHere" :class="{ hide: !showHideFlag }"></div>

      <!-- 상품롤링박스 -->
      <div
        v-if="vodInfo.broadcastPrdts"
        class="pVodProduct"
        @click="showPrdt()"
        :class="{ hide: !showHideFlag }"
      >
        <div class="pVodPrdtCnt">{{ vodInfo.prdtTotalCnt }}</div>
        <div class="prdtViewBox">
          <div
            class="prdtBox"
            :style="{
              width: (vodInfo.prdtTotalCnt + 1) * 66 + 'px',
              transform: `translateX(-${viewPrdtNo * 66}px)`
            }"
            ref="prdtSwiper"
          >
            <div
              class="productBox"
              v-for="(product, idx) in vodInfo.broadcastPrdts"
              :key="`broadcastPrdt_${idx}`"
            >
              <div
                class="imgBox"
                :style="{
                  backgroundImage: `url( ${
                    product.squareImageUrl || product.bigImageUrl
                  })`
                }"
              ></div>

              <p class="pVodPrdtPrice">
                {{ ProductService.prdtPrice(product).value | makeComma }}
              </p>
            </div>

            <!-- 복사 -->
            <div class="productBox">
              <div
                class="imgBox"
                :style="{
                  backgroundImage: `url( ${
                    vodInfo.broadcastPrdts[0].squareImageUrl ||
                    vodInfo.broadcastPrdts[0].bigImageUrl
                  })`
                }"
              ></div>

              <p class="pVodPrdtPrice">
                {{
                  ProductService.prdtPrice(vodInfo.broadcastPrdts[0]).value
                    | makeComma
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="pVodAsk"
        @click="showQna()"
        v-if="isLogin && vodInfo.broadcastPrdts"
        :class="{ hide: !showHideFlag }"
      >
        <button class="btnQnA">
          <i class="fas fa-question-circle"></i>
        </button>
      </div>

      <VideoPlayer
        :playMedia="playMedia"
        :poster="poster"
        :options="options"
        :showHideFlag="showHideFlag"
        :mode="'vod'"
        :timeUpdateFlag="true"
        :autoplay="true"
        @player="setPlayer"
        @videoClick="iconShowHide"
        v-if="playMedia.src"
      />
    </div>

    <!-- 채팅창 -->
    <div class="chatBox">
      <!-- 상품고정 -->
      <div
        class="prdtPined"
        :class="{ on: fixPrdtVisible, hide: !showHideFlag }"
      >
        <router-link
          v-if="fixPrdtSysId !== null"
          :to="`/product/${selectedPrdt.prdtSysId}/live/${selectedPrdt.broadcastProductSysId}`"
          @click.native="clickPrdt"
        >
          <div
            class="imgBox"
            :style="{
              backgroundImage: `url(${
                selectedPrdt.squareImageUrl || selectedPrdt.bigImageUrl
              })`
            }"
          ></div>
          <div class="txtBox">
            <h4>{{ selectedPrdt.name }}</h4>
            <p class="orgPrice">{{ selectedPrdt.marketPrice | makeComma }}</p>
            <p class="price">
              <span class="discount" v-if="selectedPrdt.discountRate > 0"
                >{{ selectedPrdt.discountRate }}<span>%</span></span
              >
              <span class="price"
                >{{ selectedPrdt.price | makeComma
                }}<span>{{ $t('global.unitMoney') }}</span></span
              >
            </p>
          </div>
        </router-link>

        <button
          class="prdtClose"
          v-if="fixPrdtSysId !== null"
          @click="closePrdt"
        >
          <img
            src="../../assets/img/ico/icon_live_close.png"
            :alt="$t('global.close')"
          />
        </button>
      </div>

      <!-- 홍보문구 -->
      <div
        class="marketingChat"
        :class="{ on: roomMarketing, hide: !showHideFlag }"
      >
        <div class="mChatBox" v-if="roomMarketing !== ''">
          <div class="txtChkBox" ref="txtChkBox">
            <p ref="flowText">{{ roomMarketing }}</p>
          </div>
        </div>

        <button
          class="matketClose"
          :class="{ hide: !showHideFlag }"
          v-if="roomMarketing !== ''"
          @click="closeMarket"
        >
          <img
            src="../../assets/img/ico/icon_live_close.png"
            :alt="$t('global.close')"
          />
        </button>
      </div>

      <!-- 공지사항 -->
      <div
        class="noticeChat"
        :class="{ hide: !showHideFlag || roomInfo.noti.length === 0 }"
      >
        <transition name="fade">
          <p :class="{ on: notiVisible }" @click="moreNoti()">
            <span
              ><img src="../../assets/img/ico/icon_live_notice.png" alt=""
            /></span>
            {{
              roomInfo.noti.length > 40
                ? roomInfo.noti.substring(0, 38) + '...'
                : roomInfo.noti
            }}

            <button class="notiMore" v-if="roomInfo.noti.length > 40">
              {{ $t('global.more') }}
            </button>
          </p>
        </transition>
      </div>

      <!-- 일반 채팅창 -->
      <div class="chatWrapper">
        <ul class="chatHistory" ref="chatBox" :class="{ hide: !showHideFlag }">
          <li
            v-for="(chat, idx) in chatList"
            :key="'chat_' + idx"
            :class="{
              ad: !chat.permission && chat.msgType === 0,
              me: myNick === chat.nick && chat.nick !== ''
            }"
          >
            <div class="norChat" v-if="chat.msgType === 0">
              <span
                class="chatNick"
                v-if="chat.permission && chat.msgType === 0"
                >{{ printNick(chat) }}</span
              ><span v-if="!chat.permission && chat.msgType === 0"
                ><img src="../../assets/img/ico/icon_live_adChat.png" alt=""
              /></span>
              {{ chat.msg }}
            </div>
            <div class="qa" v-if="chat.msgType === 1" @click="showAnswer(chat)">
              <p class="title">
                <span class="nick">{{ chat.nick }}</span>
                {{ $t('broadcast.arrivalAnswer') }}
              </p>
              <p class="param">
                <span class="cont">{{ chat.content }}</span>
                <button class="ans">{{ $t('broadcast.viewAnswer') }}</button>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <button
        class="hiddenBtn"
        :class="{ show: !showHideFlag, hide: showHideFlag }"
        @click="iconShowHide"
      ></button>
    </div>

    <!-- 답변 & 공지사항 컴포넌트 -->
    <section class="answerPop" :class="{ active: activePop }">
      <div class="question" v-if="Object.keys(selectedAnswer).length > 0">
        <h1>{{ $t('broadcast.viewAnswer') }}</h1>
        <button class="close" @click="closeAnswer()"></button>
        <div class="info">
          <p
            v-html="$t('broadcast.chatAnswer', { nick: selectedAnswer.nick })"
          />
          <p class="q">{{ selectedAnswer.content }}</p>
          <p class="a">{{ selectedAnswer.answer }}</p>
        </div>
      </div>
      <div class="notiPop" v-if="isNoti">
        <h1>{{ $t('mypage.notice') }}</h1>
        <button class="close" @click="closeAnswer()"></button>
        <div class="info">
          <p>{{ roomInfo.noti }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { AppBridge, parseDate } from '@/assets/js/common.js'
import ChatMinxin from './mixin/chatMixin.js'
import moment from 'moment'
import lottie from 'lottie-web'
import VideoPlayer from '@/components/shared/videoComponent'

export default {
  props: [
    'vodInfo',
    'prdtToggle',
    'pipMode',
    'viewCnt',
    'broadcastVodInfo',
    'likeCnt',
    'ProductService'
  ],
  mixins: [ChatMinxin],
  components: {
    VideoPlayer
  },
  data() {
    return {
      player: null,
      videoUiHeight: '100%',
      showPrdtFlag: false,
      showQnaFlag: false,
      vodSound: true,
      turnOn: true,
      clickSoundBtn: true,
      window: window,
      playPauseTime: 0,
      playRestartTime: 0,
      poster: null,
      iosStart: 0,
      iosEnd: 0,
      showHideFlag: true,
      chatService: null,
      chatServiceOption: {
        room: {
          room: this.broadcastVodInfo.bcScheduleSysId
        },
        user: {
          nickName: ''
        },
        mode: 'vod',
        playerBox: '.pVodWrap.vod'
      },
      startDate: this.vodInfo.liveStartDate
        ? `${this.vodInfo.liveStartDate}`
        : `${this.vodInfo.startDate} ${this.vodInfo.startTime}`,
      runningAt: this.vodInfo.liveStartDate
        ? `${this.vodInfo.liveStartDate}`
        : `${this.vodInfo.startDate} ${this.vodInfo.startTime}`,
      loadedAt: null,
      fixPrdtVisible: false,
      fixPrdtSysId: null,
      selectedPrdt: {},
      roomMarketing: '',
      roomInfo: {
        viewCnt: 0,
        likeCnt: 0,
        noti: ''
      },
      notiVisible: false,
      myNick: '',
      activePop: false,
      showPrdtModal: false,
      buyHere: null,
      viewPrdtNo: 0,
      viewPrdtTo: null,
      rollingFixPrdt: null,
      chatSeeking: 0,
      endStatus: false,
      errChk: null,
      options: {
        type: Object,
        default() {
          return {
            autoplay: 'muted',
            controls: true,
            height: 'auto',
            loop: false,
            preload: 'auto',
            width: '100%',
            controlBar: {
              fullscreenToggle: false
            },
            userActions: {
              doubleClick: false
            },
            html5: {
              hls: {
                overrideNative: true
              },
              nativeAudioTracks: false,
              nativeVideoTracks: false
            }
          }
        }
      },
      playMedia: {
        src: null,
        type: ''
      },
      newChatSize: 0,
      oldChatSize: 0,
      selectedAnswer: {},
      isNoti: false,
      chatDone: false,
      muteInit: false
    }
  },
  computed: {
    ...mapState(['isLogin']),

    brandRounting() {
      // 브랜드 이동 기능. app.vue window.routeGo2, livePlay 두군데 같이 수정 필요
      // liveInfoContent 도 수정 필요

      return `/Planning/brandList/${this.vodInfo.brandSysId}`
    }
  },
  methods: {
    // 재생 미디어 설정
    setMedia(media) {
      this.playMedia = {
        src: media.directUrl || media.hlsUrl || media.liveUrl,
        type: media.directUrl ? 'video/mp4' : 'application/x-mpegURL'
      }

      this.poster = this.urlChk(media.thumnailUrl)
    },

    printNick(chat) {
      let nick = chat.nick
      if (nick === '' && chat.userId) nick = chat.userId.substring(0, 3) + '**'

      return nick
    },

    setPlayer(player) {
      this.player = null

      this.player = player

      this.player.off('error')
      this.player.on('error', (e) => {
        console.info(e)

        // close()
      })

      this.player.on('play', () => {
        if (!this.muteInit) {
          this.vodSound = !this.player.muted()

          let muteStat = false
          if (sessionStorage.getItem('userMute')) {
            muteStat =
              sessionStorage.getItem('userMute') === 'true' ? true : false
          }

          this.player.muted(muteStat)
          this.vodSound = !muteStat
          sessionStorage.setItem('userMute', muteStat)

          this.muteInit = true
        }
      })

      // 채팅녹화가 되어있지 않으면 아래쪽 실행 안함
      if (this.vodInfo.isRecChat === 1) return false

      // 초기 채팅 내역 설정
      let loaded = new Date(parseDate(this.startDate))
      loaded.setSeconds(loaded.getSeconds())
      this.loadedAt = moment(loaded).format('YYYY-MM-DD HH:mm:ss')
      console.log(this.loadedAt)
      this.loadChatHistory()

      // 채팅 호출 이벤트바인딩
      this.player.off('timeupdate')
      this.player.on('timeupdate', (e) => {
        this.chatSeeking = this.player.currentTime()
        if (Math.abs(this.chatSeeking - this.player.currentTime()) > 5)
          return false

        let running = new Date(parseDate(this.startDate))
        running.setSeconds(running.getSeconds() + this.player.currentTime())
        this.runningAt = moment(running).format('YYYY-MM-DD HH:mm:ss')

        if (!this.loadedAt) return false

        let dif =
          (new Date(parseDate(this.loadedAt)) -
            new Date(parseDate(this.runningAt))) /
          1000
        if (dif <= 3) {
          this.loadChatHistory()
        }
      })

      this.player.off('seeked')
      this.player.on('seeked', (e) => {
        // seeked 이벤트
        this.chatList = []
        this.vodChatList = []
        this.notiVisible = false
        this.roomInfo.noti = ''
        this.closeMarket()
        this.rollingPrdt()

        let running = new Date(parseDate(this.startDate))
        running.setSeconds(running.getSeconds() + this.player.currentTime())
        this.runningAt = moment(running).format('YYYY-MM-DD HH:mm:ss')

        let dif =
          (new Date(parseDate(this.loadedAt)) -
            new Date(parseDate(this.runningAt))) /
          1000
        if (dif <= 3 || dif > 10) {
          this.loadedAt = moment(running).format('YYYY-MM-DD HH:mm:ss')
          this.loadChatHistory(true)
        }

        this.fixInfoSet()
        setTimeout(() => {
          this.chatDone = true
        }, 300)
      })
    },

    urlChk(url) {
      if (url) {
        if (url.indexOf('http') === -1 && url.indexOf('https') === -1) {
          return 'https://' + url
        } else if (url.indexOf('http') > -1 && url.indexOf('https') === -1) {
          return url.replace('http', 'https')
        } else if (url.indexOf('https') > -1) {
          return url
        }
      }
    },

    vodClosed() {
      this.playPauseTime = 0

      let vodInfo = {
        broadcastSysId: null,
        broadcastScheduleSysId: null,
        vodPlaying: false,
        pipMode: false,
        top: 0,
        right: 0
      }
      window.pastVod(vodInfo)
      AppBridge.send('VodPipExit', { value: 'close' })
      // this.$router.go(-1)
    },
    vodToggleSize() {
      if (window.pastVodPip) {
        let param = {
          pipMode: !this.pipMode,
          top: 0,
          right: 0
        }
        window.pastVod(param)
        AppBridge.send('VodScreenStatus', { value: param.pipMode }, true)
      }
    },
    showPrdt() {
      this.showPrdtFlag = true
      this.$emit('prdtListFlag', this.showPrdtFlag)
    },
    showQna() {
      this.showQnaFlag = true
      this.$emit('prdtQnaFlag', this.showQnaFlag)
    },
    soundBtn() {
      this.vodSound = !this.vodSound
      if (this.vodSound === false) {
        this.player.muted(true)
        sessionStorage.setItem('userMute', true)
      } else {
        this.player.muted(false)
        sessionStorage.setItem('userMute', false)
      }
    },
    clickFlag() {
      // vod를 pip모드로 변환
      let param = {
        pipMode: true
      }
      window.pastVod(param)
      AppBridge.send('VodScreenStatus', { value: param.pipMode }, true)
    },
    iosChangePip() {
      window.addEventListener(
        'touchstart',
        this.onStart,
        { capture: true },
        true
      )
      window.addEventListener('touchend', this.onEnd, { capture: true }, true)
    },
    onStart(e) {
      let vodBox = document.querySelector('.fp-middle')
      if (e.target === vodBox) {
        // let startPoint = parseInt((e.changedTouches[0].pageY / window.innerHeight) * 100)
        // if (84 < startPoint < 90) {
        // console.log(startPoint)
        this.iosStart = e.changedTouches[0].pageY
        // console.log('start : ', e)
        // }
      }
    },
    onEnd(e) {
      let vodBox = document.querySelector('.fp-middle')
      if (e.target === vodBox) {
        // let endPoint = parseInt((e.changedTouches[0].pageY / window.innerHeight) * 100)
        // if (70 < endPoint < 75) {
        // console.log(endPoint)
        this.iosEnd = e.changedTouches[0].pageY
        // console.log('end : ', e)
        let move = this.iosStart - this.iosEnd

        if (this.iosEnd < this.iosStart && move > 60) {
          this.clickFlag()
        }
        // }
      }
    },

    // VOD 플레이중 seek 이벤트 발생시, 해당 시점의 채팅 고정값 이벤트 발생
    fixInfoSet() {
      let runningTime = this.runningAt
      this.chatService._VodFixInfo(runningTime)
    },

    loadChatHistory(boolean) {
      let targetTime = null
      let startTime = null
      if (!this.loadedAt) {
        targetTime = new Date(parseDate(this.runningAt))
      } else {
        targetTime = new Date(parseDate(this.loadedAt))
        targetTime.setSeconds(targetTime.getSeconds() + 1)
      }

      startTime = moment(targetTime).format('YYYY-MM-DD HH:mm:ss')

      targetTime.setSeconds(targetTime.getSeconds() + 10)
      this.loadedAt = moment(targetTime).format('YYYY-MM-DD HH:mm:ss')

      if (boolean) {
        this.chatService._ChatHistory(startTime, this.loadedAt, true)
      } else {
        this.chatService._ChatHistory(startTime, this.loadedAt)
      }
    },

    printChatHist() {
      let now = this.runningAt
      let nowChat = this.vodChatList.filter((c, idx) => {
        if (c.histType === 1 || c.createdAt === now) {
          return c
        }
      })

      nowChat.forEach((x) => {
        // 중복 제거
        let di = this.vodChatList.indexOf(x)
        this.vodChatList.splice(di, 1)

        // 일반, 공지, 홍보 채팅의 경우
        if (x.msgType === 0 || x.msgType === 3 || x.msgType === 4) {
          let data = {
            user: {
              nickName: x.nickName,
              permission: x.permission,
              userId: x.userId
            },
            message: {
              msg: x.msg,
              msgType: x.msgType
            }
          }

          // console.log(x.nickName, ' : ', x.msg)
          this.printChat(data, x.msgType)

          // 구매여기
        } else if (x.msgType === 6) {
          this.buyHereAni()

          // 공지사항 해지
        } else if (x.msgType === 7) {
          this.closeNoti()

          // 상품노출
        } else if (x.msgType === 8) {
          this.fixPrdtSysId = x.prdtSysId
          setTimeout(() => {
            this.fixPrdtVisible = true
          }, 0)

          setTimeout(() => {
            this.fixPrdtVisible = false
            setTimeout(() => {
              this.fixPrdtSysId = null
            }, 1000)
          }, 6000)

          // 상품고정
        } else if (x.msgType === 9) {
          this.rollingFixPrdt = x.prdtSysId
          this.rollingFix()
        }

        this.vodChatList.forEach((x, idx) => {
          if (x.createAt < now) {
            this.vodChatList.splice(idx, 1)
          }
        })
      })
    },

    // 상품 클릭
    clickPrdt() {
      // vod를 pip모드로 변환
      let param = {
        pipMode: true
      }
      window.pastVod(param)
      AppBridge.send('VodScreenStatus', { value: param.pipMode })

      this.fixPrdtSysId = null
    },

    // 상품 롤링
    rollingPrdt() {
      let swiper = this.$refs.prdtSwiper
      let max = this.vodInfo.broadcastPrdts?.length || 0
      clearTimeout(this.viewPrdtTo)
      this.viewPrdtTo = setTimeout(() => {
        this.viewPrdtNo++

        if (this.viewPrdtNo >= max) {
          setTimeout(() => {
            if (swiper) {
              swiper.style.transition = 'none'
              this.viewPrdtNo = 0
              setTimeout(() => {
                swiper.style.transition = 'transform 0.5s ease'
              }, 0)
            }
          }, 500)
        }

        this.rollingPrdt()
      }, 4000)
    },

    // 상품롤링 고정함수
    rollingFix() {
      let prdt = this.vodInfo.broadcastPrdts.filter(
        (x) => x.prdtSysId === this.rollingFixPrdt
      )[0]
      let idx = this.vodInfo.broadcastPrdts.indexOf(prdt)
      this.viewPrdtNo = idx
      clearTimeout(this.viewPrdtTo)
    },

    // 상품고정 닫기
    closePrdt() {
      this.fixPrdtVisible = false
      setTimeout(() => {
        this.fixPrdtSysId = null
      }, 1000)
    },

    iconShowHide() {
      if (this.activePop) return (this.activePop = false)
      if (this.showPrdtModal) return this.$emit('closeModal', false)
      this.showHideFlag = !this.showHideFlag
    },

    // 공지사항 닫기
    closeNoti() {
      this.notiVisible = false
      setTimeout(() => {
        this.roomInfo.noti = ''
      }, 1000)
    },

    // 홍보문구 플로우 함수
    flowText(textEl) {
      if (this.clearVar) {
        clearTimeout(this.clearVar)
        this.clearVar = null
      }

      let width = textEl.clientWidth
      let parentWidth = textEl.parentNode.clientWidth
      textEl.style.transform = `translateX(0)`
      textEl.style.transition = `none`
      let timming = 0
      if (width > parentWidth) {
        timming = (width * 40) / 1000

        setTimeout(function () {
          textEl.style.transition = `transform ${timming}s linear`
          textEl.style.transform = `translateX(calc(-100% + ${parentWidth}px))`
        }, 800)
      }
      this.clearVar = setTimeout(
        function () {
          this.roomMarketing = ''
          textEl.style.width = '0px'
        }.bind(this),
        timming * 1000 + 5000
      )
    },

    // 홍보문구 닫기
    closeMarket() {
      this.roomMarketing = ''
    },

    // 채팅창 스크롤 가장 하단으로
    chatScroll() {
      let box = this.$refs.chatBox
      // box.scrollTop = box.scrollHeight

      let st = box.scrollTop
      let dif = 0
      if (this.oldChatSize === 0) {
        this.oldChatSize = this.newChatSize
      } else if (
        this.oldChatSize !== this.newChatSize &&
        this.oldChatSize >= this.newChatSize
      ) {
        dif = this.oldChatSize - this.newChatSize
        st = st + dif
      }

      if (box.scrollHeight - (st + box.clientHeight) <= 150) {
        box.scrollTop = box.scrollHeight
      }
      this.oldChatSize = this.newChatSize

      if (this.chatDone) {
        box.scrollTop = box.scrollHeight
        this.chatDone = false
      }
    },

    // 구매여기 아이콘
    buyHereAni() {
      this.buyHere.stop()
      this.buyHere.play()
    },

    chkScroll() {
      let box = this.$refs.chatBox
      let dif = box.scrollHeight - (box.scrollTop + box.clientHeight)
      if (dif >= 150) {
        this.isScrolled = true
      } else {
        this.isScrolled = false
      }
    },

    // 채팅창 최하단 이동
    chatDown() {
      this.$refs.chatBox.scrollTop = this.$refs.chatBox.scrollHeight
    },

    // 답변보기 클릭시
    showAnswer(data) {
      if (this.closingPop) return false
      this.selectedAnswer = data
      this.activePop = true
      this.isNoti = false
    },

    // 답변보기 닫기
    closeAnswer() {
      this.activePop = false
      this.closingPop = true
      setTimeout(() => {
        this.selectedAnswer = {}
        this.isNoti = false
        this.closingPop = false
      }, 1000)
    },

    // 공지 더보기
    moreNoti() {
      if (this.closingPop) return false
      this.selectedAnswer = {}
      this.isNoti = true
      this.activePop = true
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.setMedia(this.vodInfo.broadcastMedias[0])

      let nav = navigator.userAgent.toLowerCase()
      if (
        nav.indexOf('iphone') > -1 ||
        nav.indexOf('ipad') > -1 ||
        nav.indexOf('ipod') > -1 ||
        nav.indexOf('macintosh') > -1
      ) {
        this.iosChangePip()
      }

      // 채팅녹화가 되어있지 않으면 아래쪽 실행 안함
      if (this.vodInfo.isRecChat === 1) return false

      // 구매여기 아이콘 호출
      this.buyHere = lottie.loadAnimation({
        container: this.$refs.buyHere,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: '/static/images/purchaseanim.json'
      })

      // 상품 롤링
      this.rollingPrdt()
    })

    // 채팅창 스크롤 이벤트 리스너
    this.$refs.chatBox.addEventListener('scroll', (e) => this.chkScroll())
  },

  updated() {
    this.$nextTick(() => {
      // 채팅녹화가 되어있지 않으면 아래쪽 실행 안함
      if (this.vodInfo.isRecChat === 1) return false

      this.newChatSize = this.$refs.chatBox.clientHeight
      this.chatScroll()
    })
  },

  watch: {
    chatList: {
      handler() {
        if (this.chatList.length >= 51) this.chatList.splice(0, 1)
      }
    },

    vodInfo: {
      handler(nd, od) {
        if (nd.broadcastSysId !== od.broadcastSysId) {
          this.setMedia(nd.broadcastMedias[0])

          this.chatServiceOption.room.room =
            this.broadcastVodInfo.bcScheduleSysId
          this.startDate = `${nd.startDate} ${nd.startTime}`
          this.runningAt = `${nd.startDate} ${nd.startTime}`
          this.roomInfo.viewCnt = 0
          this.roomInfo.likeCnt = 0
          this.roomInfo.noti = ''
          this.chatList = []
          this.vodChatList = []
          this.fixPrdtVisible = false
          this.fixPrdtSysId = null
          this.viewPrdtNo = 0
          this.muteInit = false
        }
      }
    },

    runningAt: {
      handler(or, nr) {
        if (or !== nr) {
          this.printChatHist()
        }
      }
    },

    roomMarketing: {
      handler(ot, nt) {
        if (this.roomMarketing !== '' && ot !== nt) {
          setTimeout(() => {
            this.$refs.flowText.style.width = 'auto'
            this.$refs.txtChkBox.style.width = '100000px'
            let width = this.$refs.flowText.clientWidth + 1 + 'px'
            this.$refs.flowText.style.width = width
            this.$refs.txtChkBox.style.width = width
            this.flowText(this.$refs.txtChkBox)
          }, 0)
        }
      }
    },

    fixPrdtSysId: {
      handler() {
        if (this.fixPrdtSysId) {
          this.selectedPrdt = this.vodInfo.broadcastPrdts.filter(
            (x) => x.prdtSysId === this.fixPrdtSysId
          )[0]
        }
      }
    },
    chatDone: {
      handler(val) {
        if (val) {
          console.log(
            document.body.scrollHeight,
            this.$refs.chatBox.scrollHeight,
            this.chatList.length
          )
          this.$refs.chatBox.scrollTop = this.$refs.chatBox.scrollHeight
        }
      }
    }
  },

  beforeDestroy() {
    window.closePip()
    if (this.chatService) {
      this.chatService._clearChatService()
      this.chatService = null
    }

    this.$refs.chatBox.removeEventListener('scroll', this.chkScroll())
  }
}
</script>
<style>
.pVodWrap,
.pVodWrap .pVodInner {
  width: 100%;
  height: 100%;
}

.pVodWrap .pipClose {
  position: absolute;
  top: 0;
  right: -40px;
  z-index: 15;
  width: 30px;
  height: 30px;
  background: url('../../assets/img/ico/ico_pipClose.png') 50% 50% / 30px auto
    no-repeat;
  font-size: 1px;
  color: transparent;
  transition: all 0.3s ease;
  opacity: 0;
}

.pipMod .pVodWrap .pipClose {
  animation: visible 0.3s alternate forwards;
}
@keyframes visible {
  0% {
    opacity: 0;
    right: -40px;
  }
  100% {
    opacity: 1;
    right: 0;
  }
}

.pVodWrap .pVodInner .topDiv {
  width: 100%;
  height: 25%;
  position: absolute;
  object-fit: contain;
  z-index: 2;
  /* overflow: scroll; */
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.25),
    rgba(0, 0, 0, 0)
  );
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.pVodWrap .pVodInner .bottomDiv {
  width: 100%;
  height: 60%;
  bottom: 0;
  position: absolute;
  object-fit: contain;
  z-index: 2;
  /* overflow: scroll; */
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.3s ease;
}
.pipMod .pVodWrap .pVodInner .topDiv,
.pipMod .pVodWrap .pVodInner .bottomDiv {
  opacity: 0;
}

.pVodWrap .pVodInner .pVodTop img {
  position: absolute;
  object-fit: contain;
  z-index: 5;
  overflow: hidden;
}

.pVodWrap .pVodInner .pVodTop .logo {
  position: absolute;
  width: 62px;
  height: 26px;
  top: 20px;
  left: 9px;
  object-fit: contain;
  z-index: 5;
  overflow: hidden;
}

.pVodWrap .pVodInner .pVodTop .live {
  position: absolute;
  width: 54px;
  height: 26px;
  top: 20px;
  left: 80px;
  object-fit: contain;
  z-index: 5;
  overflow: hidden;
}

.pVodWrap .pVodInner .brandImg {
  position: absolute;
  z-index: 5;
  top: 55px;
  left: 7px;
  overflow: hidden;
  width: 100%;
  margin-left: 1px;
}
.pVodWrap .pVodInner .brandImg a {
  display: block;
  float: left;
  z-index: 5;
}

.pVodWrap .pVodInner .brandImg .brdImgDiv {
  z-index: 5;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: solid 1px #dbdbdb;
  box-sizing: border-box;
  overflow: hidden;
  margin: 5px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  background-color: #fff;
}
.pVodWrap .pVodInner .brandImg .brdImg {
  z-index: 5;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: block;
}

.pVodWrap .pVodInner .brandImg .rerDiv {
  position: absolute;
  top: 34px;
  left: 1px;
  width: 50px;
  height: 18px;
  padding: 3px;
}

.pVodWrap .pVodInner .brandImg .rerDiv .rerun {
  object-fit: cover;
  position: relative;
  /* top: 34px; */
  width: 50px;
  height: 18px;
  z-index: 5;
  border-radius: 50px;
  box-sizing: border-box;
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05);
  background-image: linear-gradient(to right, var(--warm-grey) 2%, #767676 99%);
}
.pVodWrap .pVodInner .brandTxt {
  z-index: 5;
  font-size: 15px;
  width: calc(100% - 62px);
  /* margin-top: 7px; */
  margin-left: 4px;
  color: #fff;
  float: left;
}
.pVodWrap .pVodInner .brandTxt p {
  z-index: 5;
  text-shadow: 0 1px 2px rgba(20, 20, 20, 0.4);
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.64px;
  text-align: left;
  color: #ffffff;
  padding-right: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: calc(100% - 10px);
  box-sizing: border-box;
  word-wrap: normal;
  margin-bottom: 6px;
}

.pVodWrap .pVodInner .brandTxt span {
  text-shadow: 0 1px 2px rgba(20, 20, 20, 0.4);
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.56px;
  text-align: left;
  color: #ffffff;
  z-index: 5;
}

.pVodWrap .pVodInner .brandTxt .watchCnt {
  display: inline-block;
  margin-left: 8px;
}
.pVodWrap .pVodInner .brandTxt .likeCnt {
  display: inline-block;
  margin-left: 4px;
}

.pVodWrap .pVodInner .brandTxt .watchCnt img,
.pVodWrap .pVodInner .brandTxt .likeCnt img {
  width: 20px;
  height: 20px;
  padding: 3px 3px;
  object-fit: contain;
  vertical-align: middle;
  z-index: 5;
}

.pVodWrap .pVodInner .brandTxt .watchCnt span,
.pVodWrap .pVodInner .brandTxt .likeCnt span {
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.48px;
  text-align: left;
  color: #ffffff;
  z-index: 5;
}

.pVodWrap .pVodInner .pVodSoundDiv .pVodSound {
  position: absolute;
  z-index: 5;
  width: 30px;
  height: 30px;
  object-fit: contain;
  top: 14px;
  right: 55px;
  background: url('../../assets/img/ico/icon_sound_on_wh.png') 0 0 / 100% auto
    no-repeat;
}

.pVodWrap .pVodInner .pVodSoundDiv .pVodSound.off {
  z-index: 5;
  background: url('../../assets/img/ico/icon_sound_off_wh.png') 0 0 / 100% auto
    no-repeat;
}

.pVodWrap .pVodInner .pVodSizingBtn {
  position: absolute;
  top: 14px;
  right: 9px;
  z-index: 10;
  display: block;
  width: 30px;
  height: 30px;
  background: url('../../assets/img/ico/icon_exit_full-screen_wh.png') 0 0 /
    30px 30px no-repeat;
  opacity: 1;
  transition: all 0.3s ease-in-out;
}
.pipMod .pVodWrap .pVodInner .pVodSizingBtn {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 5;
}

.pVodWrap .pVodInner .pVodIconShow.show {
  position: absolute;
  top: 14px;
  right: 55px;
  z-index: 10;
  display: block;
  width: 30px;
  height: 30px;
  background: url('../../assets/img/ico/icon_hide_wh.png') 0 0 / 30px 30px
    no-repeat;
  opacity: 1;
  transition: all 0.3s ease-in-out;
}

.pVodWrap .pVodInner .pVodIconShow.hide {
  position: absolute;
  top: 14px;
  right: 55px;
  z-index: 10;
  display: block;
  width: 30px;
  height: 30px;
  opacity: 1;
  transition: all 0.3s ease-in-out;
  background: url('../../assets/img/ico/icon_show_wh.png') 0 0 / 30px 30px
    no-repeat;
}

.pVodWrap .pVodInner .pVodClose .closeX {
  position: absolute;
  z-index: 10;
  overflow: hidden;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  background: url('../../assets/img/ico/icon_close_wh.png') 0 0 / 100% auto
    no-repeat;
}

.vod.pVodWrap .pVodInner .pVodProduct {
  position: absolute;
  z-index: 10;
  bottom: 45px;
  right: 12px;
  width: 70px;
}

.pVodWrap .pVodInner .pVodProduct img {
  width: 64px;
  height: 58px;
  /* padding: 5px; */
  border-radius: 4px;
  border: solid 1px #ededed;
  float: left;
  z-index: 10;
}

.pVodWrap .pVodInner .pVodProduct .pVodPrdtCnt {
  float: right;
  width: 20px;
  height: 16px;
  border-radius: 4px;
  background-color: #e61754;
  text-align: center;
  position: relative;
  right: 0;
  top: 11px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.48;
  letter-spacing: -0.48px;
  color: #ffffff;
  z-index: 10;
}
.pVodWrap .pVodInner .pVodProduct .pVodPrdtPrice {
  width: 66px;
  height: 16px;
  text-align: center;
  vertical-align: middle;
  float: left;
  position: relative;
  background-color: white;
  left: 0px;
  bottom: 14px;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.45;
  letter-spacing: -0.44px;
  color: #191919;
  border-radius: 4px;
  border-bottom: solid 1px #ededed;
  z-index: 10;
}

.pVodWrap .prdtToggleBox {
  height: 100px;
  width: 100%;
  z-index: 10;
}

.pVodWrap.vod .buyHere {
  bottom: 110px;
}

.pVodWrap .pVodInner .pVodAsk {
  position: absolute;
  z-index: 10;
  bottom: 45px;
  right: 93px;
  overflow: hidden;
  width: 40px;
  height: 40px;
  opacity: 0.6;
  border-radius: 8px;
  background-color: #000000;
}

.pVodWrap .pVodInner .pVodAsk .btnQnA {
  width: 24px;
  height: 24px;
  margin: 7px 7px;
  color: #fff;
  font-size: 20px;
  object-fit: contain;
  line-height: 1;
}

.pVodWrap .pVodInner .muteBtn {
  background: url('../../assets/img/ico/icon_sound_off_wh_sm.png') 0 0 / 20px
    20px no-repeat;
  z-index: 10;
}

.pVodWrap .pVodInner .flowplayer.is-muted .fp-volumebtn:after {
  display: none;
}

.pVodWrap .pVodInner .flowplayer .fp-switch.fp-play-1 .fp-pause {
  background: url('../../assets/img/ico/icon_fuzz_btn_wh@3x.png') 50% 50% / 100%
    auto no-repeat;
  z-index: 10;
}

.pVodWrap .pVodInner .flowplayer .fp-switch.fp-play-1 .fp-play {
  background: url('../../assets/img/ico/icon_play_btn_wh@3x.png') 50% 50% / 100%
    auto no-repeat;
  z-index: 10;
}

.pVodWrap .pVodInner .flowplayer .fp-switch.fp-play-1 {
  width: 85px;
  height: 85px;
}

.pVodWrap .pVodInner .is-seeking .fp-switch.fp-play-1,
.pVodWrap .pVodInner .is-waiting .fp-switch.fp-play-1 {
  display: none;
}

.pVodWrap .pVodInner .fp-timeline,
.pVodWrap .pVodWrap .pVodInner .fp-duration {
  z-index: 10;
}

.pVodWrap .pVodInner .pVodTop.hide,
.pVodWrap .pVodInner .brandImg.hide,
.pVodWrap .pVodInner .pVodSoundDiv.hide,
.pVodWrap .pVodInner .pVodProduct.hide,
.pVodWrap .pVodInner .pVodAsk.hide {
  display: none;
}

.pVodWrap .chatBox {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 7;
  display: block;
  width: calc(100% - 120px);
  margin-left: 10px;
  height: calc(100% - 170px);
  box-sizing: border-box;
  pointer-events: none;
}
.pipMod .pVodWrap .chatBox {
  position: absolute;
}
.pVodWrap .chatBox .prdtPined {
  position: relative;
  z-index: 7;
  width: 100%;
  height: 70px;
  transition: all 1s ease;
  opacity: 0;
  pointer-events: none;
}
.pVodWrap .chatBox .prdtPined.on {
  opacity: 1;
  pointer-events: all;
}
.pVodWrap .chatBox .prdtPined a {
  overflow: hidden;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.2);
}
.pVodWrap .chatBox .prdtPined .imgBox {
  float: left;
  width: 70px;
  height: 70px;
  background-size: contain;
  background-position: 50% 50%;
  background-repeat: no-repeat;
}
.pVodWrap .chatBox .prdtPined .txtBox {
  float: left;
  width: calc(100% - 78px);
  height: 100%;
  margin-left: 8px;
  padding: 5px 0;
  color: #fff;
  line-height: 1.29;
  letter-spacing: -0.56px;
  box-sizing: border-box;
}
.pVodWrap .chatBox .prdtPined .txtBox h4 {
  overflow: hidden;
  width: calc(100% - 38px);
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  font-weight: 400;
}
.pVodWrap .chatBox .prdtPined .txtBox .orgPrice {
  margin: 2px 0;
  color: #dbdbdb;
  text-decoration: line-through;
}
.pVodWrap .chatBox .prdtPined .txtBox .price {
  overflow: hidden;
  font-size: 18px;
  font-weight: 700;
}
.pVodWrap .chatBox .prdtPined .txtBox .discount {
  color: #ffe24d;
}
.pVodWrap .chatBox .prdtPined .txtBox .discount span,
.pVodWrap .chatBox .prdtPined .txtBox .price .price span {
  margin-left: 1px;
  font-size: 14px;
  font-weight: 400;
  vertical-align: middle;
}
.pVodWrap .chatBox .prdtPined .txtBox .price .price {
  margin-left: 4px;
}

.pVodWrap .chatBox .marketingChat {
  position: relative;
  width: 100%;
  height: 37px;
  margin-top: 10px;
  padding: 0 24px 0 10px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.2);
  transition: all 1s ease;
  opacity: 0;
  box-sizing: border-box;
}
.pVodWrap .chatBox .marketingChat.on {
  opacity: 1;
}
.pVodWrap .chatBox .marketingChat.hide {
  display: block;
  opacity: 0;
}
.pVodWrap .chatBox .marketingChat.hide .matketClose.hide {
  display: none;
}
.pVodWrap .chatBox .marketingChat .mChatBox {
  overflow: hidden;
}
.pVodWrap .chatBox .marketingChat p {
  display: inline-block;
  color: #ffca85;
  line-height: 37px;
}
.pVodWrap .chatBox .marketingChat .matketClose,
.pVodWrap .chatBox .prdtPined .prdtClose {
  position: absolute;
  top: 8px;
  right: 3px;
  display: block;
  width: 20px;
  height: 20px;
  background: transparent;
  pointer-events: all;
}
.pVodWrap .chatBox .marketingChat .matketClose img,
.pVodWrap .chatBox .prdtPined .prdtClose img {
  display: block;
  width: 100%;
}

.pVodWrap .chatBox .noticeChat {
  width: 100%;
  height: 48px;
  margin-top: 10px;
  color: #ffe24d;
  pointer-events: all;
}
.pVodWrap .chatBox .noticeChat p {
  position: relative;
  padding: 4px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.2);
  letter-spacing: -0.56px;
  transition: all 1s ease;
  opacity: 0;
}
.pVodWrap .chatBox .noticeChat p.on {
  opacity: 1;
}
.pVodWrap .chatBox .noticeChat span {
  display: inline-block;
  height: 20px;
  vertical-align: top;
}
.pVodWrap .chatBox .noticeChat span img {
  display: block;
  height: 100%;
}
.pVodWrap .chatBox .noticeChat .notiMore {
  float: none;
  position: absolute;
  right: -65px;
  bottom: 0;
  display: block;
  width: 60px;
  height: auto;
  background-color: transparent;
  background-image: url('../../assets/img/ico/icon_live_arrow.png');
  background-position: 100% 50%;
  background-size: 20px;
  background-repeat: no-repeat;
  color: #fff;
  text-align: left;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}
.pVodWrap .chatBox .chatWrapper {
  position: absolute;
  left: 0;
  bottom: 98px;
  z-index: 4;
  overflow: hidden;
  width: 100%;
  height: calc(100% - 275px);
  font-size: 14px;
  line-height: 1.29;
  box-sizing: border-box;
  pointer-events: all;
}

.pVodWrap .chatBox .chatHistory {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  max-height: calc(100% - 30px);
  overflow-y: auto;
  overflow-x: hidden;
  pointer-events: all;
}

.pVodWrap .chatBox .chatHistory li {
  overflow-x: hidden;
  width: 100%;
  margin: 3px 0;
  color: #fff;
  text-shadow: 1px 1px 2px rgb(0, 0, 0, 0.5);
}
.pVodWrap .chatBox .chatHistory li > div {
  display: inline-block;
  width: auto;
  max-width: 100%;
  padding: 2px 5px 1px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.17);
  border-radius: 5px;
}
.pVodWrap .chatBox .chatHistory li .chatNick {
  margin-right: 4px;
  color: #fff;
  opacity: 0.8;
}
.pVodWrap .chatBox .chatHistory li.me .chatNick {
  color: #ff8000;
}
.pVodWrap .chatBox .chatHistory li.ad {
  color: #ffe24d;
}
.pVodWrap .chatBox .chatHistory li.ad span {
  overflow: hidden;
  display: inline-block;
  height: 14px;
}
.pVodWrap .chatBox .chatHistory li.ad img {
  position: relative;
  top: -2px;
  width: 20px;
  vertical-align: middle;
}
.pVodWrap .chatBox .qa .title {
  display: inline-block;
  width: auto;
  height: 28px;
  padding: 0 10px 0 20px;
  box-sizing: border-box;
  border-radius: 14px;
  background-color: rgba(0, 0, 0, 0.2);
  background-image: url('../../assets/img/ico/icon_live_answer2.png');
  background-position: 0px 4px;
  background-size: 20px auto;
  background-repeat: no-repeat;
  line-height: 30px;
  letter-spacing: -0.56px;
}
.pVodWrap .chatBox .me .qa .title {
  background-image: url('../../assets/img/ico/icon_live_answer.png');
}
.pVodWrap .chatBox .qa .title .nick {
  margin-right: 4px;
  color: #ffe24d;
}
.pVodWrap .chatBox .me .qa .title .nick {
  color: #ff8000;
}
.pVodWrap .chatBox .qa .param {
  overflow: hidden;
  width: 100%;
  margin-top: 3px;
  padding: 0 0 0 20px;
  box-sizing: border-box;
  background-image: url('../../assets/img/ico/icon_live_reply.png');
  background-position: 0 0;
  background-size: 20px auto;
  background-repeat: no-repeat;
  letter-spacing: -0.56px;
  line-height: 20px;
  box-sizing: border-box;
}
.pVodWrap .chatBox .qa .param .cont {
  float: left;
  display: block;
  overflow: hidden;
  width: calc(100% - 80px);
  text-overflow: ellipsis;
  word-wrap: normal;
  white-space: nowrap;
  line-height: inherit;
}
.pVodWrap .chatBox .qa .param .ans {
  position: relative;
  top: -2px;
  float: right;
  display: block;
  width: 70px;
  height: auto;
  color: #fff;
  background-color: transparent;
  background-image: url('../../assets/img/ico/icon_live_arrow.png');
  background-position: 100% 50%;
  background-size: 20px auto;
  background-repeat: no-repeat;
  text-align: left;
  text-shadow: inherit;
  line-height: inherit;
  outline: none;
}

.pVodWrap .chatBox form {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 15;
  overflow: hidden;
  display: block;
  width: calc(100% - 152px);
  height: 44px;
  margin-left: 60px;
  padding-bottom: 14px;
}
.pVodWrap .chatBox form.full {
  width: 100%;
  margin-left: 0;
}
.pVodWrap .chatBox .hiddenBtn {
  position: fixed;
  left: 10px;
  bottom: 45px;
  z-index: 17;
  display: block;
  width: 40px;
  height: 40px;
  outline: none;
  pointer-events: all;
}
.pVodWrap .chatBox .hiddenBtn.show {
  background: url('../../assets/img/ico/icon_live_hiddenBtnV.png') 0 0 / 40px
    40px no-repeat;
}
.pVodWrap .chatBox .hiddenBtn.hide {
  background: url('../../assets/img/ico/icon_live_hiddenBtn.png') 0 0 / 40px
    40px no-repeat;
}

.pVodWrap .chatBox input {
  float: left;
  display: block;
  width: 100%;
  height: 44px;
  padding: 0 10px;
  border: 1px solid #fff;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.2);
  font-size: 16px;
  color: #fff;
  box-sizing: border-box;
  outline: none;
}
.pVodWrap .chatBox .hide input {
  display: none;
}
.pVodWrap .chatBox button {
  display: none;
  float: left;
  width: 70px;
  height: 44px;
  background: #fff;
  color: #408ef7;
}
.pVodWrap .chatBox button.disabled {
  color: #a7a7a7;
}
.pVodWrap .chatBox input:-ms-input-placeholder {
  color: #fff;
}
.pVodWrap .chatBox input::placeholder {
  color: #fff;
}
.pVodWrap .chatBox input::-webkit-input-placeholder {
  color: #fff;
}

.pVodWrap .chatBox.chatting {
  z-index: 11;
}
.pVodWrap .chatBox.chatting form {
  padding-bottom: 0;
}
.pVodWrap .chatBox.chatting .hiddenBtn {
  display: none;
}
.pVodWrap .chatBox input:focus,
.pVodWrap .chatBox.chatting input {
  float: left;
  width: calc(100% - 70px);
  border-radius: 0;
  margin-left: 0;
  background: #fff;
  color: #191919;
}
.pVodWrap .chatBox input:focus + button,
.pVodWrap .chatBox.chatting input + button {
  display: block;
}
.pVodWrap .chatBox input:focus:-ms-input-placeholder,
.pVodWrap .chatBox.chatting input:focus:-ms-input-placeholder {
  color: #a7a7a7;
}
.pVodWrap .chatBox input:focus::placeholder,
.pVodWrap .chatBox.chatting input:focus::placeholder {
  color: #a7a7a7;
}
.pVodWrap .chatBox input:focus::-webkit-input-placeholder,
.pVodWrap .chatBox.chatting input:focus::-webkit-input-placeholder {
  color: #a7a7a7;
}

.pVodWrap .answerPop {
  overflow: hidden;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 20;
  width: 100%;
  height: 0;
  border-radius: 12px 12px 0 0;
  background: #fff;
  transition: all 0.5s ease-in-out;
  transform: translateY(100%);
}
.pVodWrap .answerPop.active {
  transform: translateY(0);
  height: 50%;
}
.pVodWrap .answerPop h1 {
  width: calc(100% - 20px);
  margin-left: 10px;
  padding: 17px 0 13px;
  font-size: 16px;
  font-weight: 500;
  border-bottom: 1px solid #ddd;
  line-height: 1;
}
.pVodWrap .answerPop .close {
  position: absolute;
  top: 12px;
  right: 10px;
  display: block;
  width: 24px;
  height: 24px;
  background: url('../../assets/img/ico/icon_close_bk.png') 50% 50% / 24px auto
    no-repeat;
}
.pVodWrap .answerPop .info {
  padding: 10px;
  color: #767676;
}
.pVodWrap .answerPop .notiPop .info {
  color: #111;
}
.pVodWrap .answerPop .info p {
  margin-bottom: 20px;
}
.pVodWrap .answerPop .info p:first-child {
  font-weight: 700;
}
.pVodWrap .answerPop .notiPop .info p:first-child {
  font-weight: 400;
}
.pVodWrap .answerPop .info p:first-child > span {
  font-weight: 400;
}
.pVodWrap .answerPop .info .q {
  margin: 10px 0;
  font-size: 15px;
  color: #111;
  line-height: 1.29;
  word-break: break-all;
}
.pVodWrap .answerPop .info .q:before {
  content: 'Q';
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 5px;
  border-radius: 50%;
  background: #ececec;
  font-size: 12px;
  text-align: center;
  line-height: 24px;
  color: #5c5c5c;
  vertical-align: middle;
}
.pVodWrap .answerPop .info .a {
  margin: 10px 0;
  font-size: 15px;
  color: #111;
  line-height: 1.29;
  word-break: break-all;
}
.pVodWrap .answerPop .info .a:before {
  content: 'A';
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 5px;
  border-radius: 50%;
  background: #ececec;
  font-size: 12px;
  text-align: center;
  line-height: 24px;
  color: #e61754;
  vertical-align: middle;
}

.vod .pVodInner .video-js {
  height: 100%;
}
.vod .pVodInner .video-js .vjs-tech {
  height: 100%;
}
</style>